import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

type PillSize = 'small' | 'large';
type PillType = 'solid' | 'subtle' | 'priority';
type PillStatus =
    | 'success'
    | 'low-severity'
    | 'med-severity'
    | 'high-severity'
    | 'critical'
    | 'new'
    | 'active'
    | 'inactive'
    | 'open'
    | 'closed'
    | 'pending';
type PillColorSolid =
    | 'dark-green'
    | 'teal'
    | 'light-blue'
    | 'dark-blue'
    | 'blue-purple'
    | 'violet'
    | 'pink'
    | 'magenta'
    | 'salmon-pink'
    | 'charcoal-gray'
    | 'default';
type PillColorSubtle =
    | 'green'
    | 'ocean-blue'
    | 'red'
    | 'yellow'
    | 'orange'
    | 'bittersweet'
    | 'violet'
    | 'sky-blue'
    | 'purple'
    | 'black'
    | 'turquoise'
    | 'lavender';

@Component({
    selector: 'itc-tag',
    template: `
        <p
            class="itc tag {{ size }} {{ type }} {{ statusName }} {{ color }}"
            [ngClass]="{ pill: pill, closable: closable }"
            (click)="onClicked($event)">
            <span class="tag-text"><ng-content></ng-content></span>
        </p>
    `,
    styleUrls: ['./itc-tag.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ItcTagComponent {
    @Input() pill = true;
    @Input() size: PillSize = 'small';

    @Input() closable = false;
    @Input() type: PillType = 'solid';
    @Input() color: PillColorSolid | PillColorSubtle = 'default';
    @Input() status: PillStatus | string;
    // all this because my code highlighting doesn't like me using 'status' in the template
    get statusName() {
        return this.status;
    }

    @Output() clicked = new EventEmitter<boolean>();
    @Output() closed = new EventEmitter<boolean>();

    onClicked(evt: Event) {
        evt.stopPropagation();
        this.clicked.emit(true);
    }
    onClose(evt: Event) {
        evt.stopPropagation();
        this.closed.emit(true);
    }
}
